import {
  getTaskType,
  getTaskTypeIcons,
} from "../../../utils/accordion/accordionHelper";
import accordion_images from "../../../utils/accordion/accordion_images";
import { checkTommorow } from "../../../utils/common-utils";

// Mapping for event types to handle icons and labels more efficiently
const eventTypeMappings = {
  Reminder: "Reminder",
  Appreciation: "Got an appreciation from your teacher",
  LevelUp: "Got a Level Up from your teacher",
  chapterEndAssessmentAssigned: "Teacher assigned chapter end assessment",
  customAssessmentAssigned: "Teacher has assigned a multi-subtopic assessment",
  experientialLearningAssigned: "Teacher assigned an experiential Homework",
  sectionUnlocked: "New Subtopic unlocked",
  default: "Teacher has assigned you a Homework",
};

// Utility function to return icons for various event types
const eventTypeIconMappings = {
  Reminder: accordion_images.updatesReminder,
  Appreciation: accordion_images.updatesAppreciation,
  LevelUp: accordion_images.updatesLevelUp,
  chapterEndAssessment_advanced: accordion_images.updatesAdvanced,
  chapterEndAssessment_proficient: accordion_images.updatesProficient,
  customAssessmentAssigned: accordion_images.customSubtopicInfo,
  experientialLearningAssigned: accordion_images.updatesExperiential,
  sectionUnlocked: accordion_images.updatesUnlock,
  default: accordion_images.updatesTask,
};

// Helper to check task proficiency for chapter end assessment
const getChapterEndAssessmentIcon = (item) => {
  const proficiency = item?.update_data?.taskAttributes?.proficiencyLevel;
  return proficiency === "advanced"
    ? eventTypeIconMappings.chapterEndAssessment_advanced
    : eventTypeIconMappings.chapterEndAssessment_proficient;
};

export const updateType = (val) =>
  eventTypeMappings[val] || eventTypeMappings.default;

export const getSubjectName = (item) =>
  item?.update_type === "sectionUnlocked"
    ? item?.update_data?.subjectName
    : item?.update_data?.taskAttributes?.subjectName;

export const getTopicName = (item) =>
  item?.update_type === "sectionUnlocked"
    ? item?.update_data?.topicName
    : item?.update_data?.taskAttributes?.topicName;

export const getSubtopicName = (item) => {
  if (item?.update_data?.taskAttributes?.chapterEndAssessment) {
    return item?.update_data?.taskAttributes?.proficiencyLevel === "proficient"
      ? "Proficient"
      : "Advanced";
  } else {
    switch (item?.update_type) {
      case "sectionUnlocked":
        return item?.update_data?.subtopicName;
      case "chapterEndAssessmentAssigned":
        return item?.update_data?.taskAttributes?.proficiencyLevel ===
          "proficient"
          ? "Proficient"
          : "Advanced";
      case "experientialLearningAssigned":
        return "";
      case "customAssessmentAssigned":
        return "";
      default:
        return item?.update_data?.taskAttributes?.subtopicName;
    }
  }
};

export const getDueDate = (item) => {
  if (item?.update_type === "sectionUnlocked") {
    return checkTommorow(item?.timestamp, true, false);
  }
  const { taskStatus, dueDate, updatedAt } = item?.update_data || {};
  return taskStatus === "completed"
    ? checkTommorow(updatedAt, true, false)
    : checkTommorow(dueDate, true, false);
};

export const getUpdatesTaskType = (item) =>
  item?.update_type === "sectionUnlocked"
    ? null
    : item?.update_type === "experientialLearningAssigned"
    ? null
    : getTaskType(item?.update_data?.taskType);

export const getUpdatesTaskTypeIcons = (item) =>
  item?.update_type === "sectionUnlocked"
    ? null
    : getTaskTypeIcons(item?.update_data?.taskType);

export const getUnlockIcon = (item) =>
  item?.update_data?.taskStatus === "completed"
    ? accordion_images.subTopicTasksCompleted
    : accordion_images.updatesUnlockWithoutBackground;

export const getEventTypeIcon = (item) => {
  const { update_type, update_data } = item;
  if (update_type === "chapterEndAssessmentAssigned") {
    return getChapterEndAssessmentIcon(item);
  }
  return eventTypeIconMappings[update_type] || eventTypeIconMappings.default;
};

// export const isDueDateColor = (item) =>
//   item?.update_data?.taskStatus === "notStarted";
export const isDueDateColor = (item) => {
  if (item?.update_type === "sectionUnlocked") {
    return "sectionGrey";
  } else {
    if (item?.update_data?.taskStatus === "notStarted") {
      return "red";
    } else if (item?.update_data?.taskStatus === "inProgress") {
      return "inProgressGrey";
    } else {
      return "completedGrey";
    }
  }
};

export const getCustomAssessmentSubtopics = (item) => {
  if (item?.update_type === "customAssessmentAssigned") {
    const subtopicNames = item?.update_data?.taskAttributes?.subtopicList
      ?.map((subtopic) => subtopic?.name)
      ?.filter((name) => name)
      ?.join(", ");
    return subtopicNames;
  } else {
    return "";
  }
};
